import ReactDOM from "react-dom";
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";

import Modal from "../common/Modal";
import ModalInnerWrapper from "../common/ModalInnerWrapper";
import PannelBody from "./PannelBody";
import Button from "../common/Button";
import { sendMailApi } from "../../lib/fetchApi";
import { formatPatientName } from "../../lib/patientName";
import { notificationActions } from "../../store/notifications";
import InputBox from "../common/interactive/InputBox";
import { getMailTemplates } from "../../lib/systemData";
import WysiwygEditor from "../common/WysiwygEditor";

import classes from './SendSmsComponent.module.css'
import CustomSelect from "../common/interactive/CustomSelect";
import Backdrop from "../common/modal/Backdrop";

export default function SendMailComponentBlank({children, mail, data, type}) {

    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const [modalOpened, setModalOpened] = useState(false)
    const [templates, setTemplates] = useState(null)

    const [selectedTemplate, setSelectedTemplate] = useState(null)

    const [notesValue, setNotesValue] = useState(null)
    const [subjectValue, setSubjectValue] = useState(null)


    const [htmlEditorValue, setHtmlEditorValue] = useState(null)

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)



    function openModal() {
        setModalOpened(true)
    }

    function closeModal() {
        setModalOpened(false)
    }


    async function sendSms(event) {
        event.preventDefault()
        setLoading(true)

        const fd = new FormData(event.target)

        const formData = Object.fromEntries(fd.entries())

        let reqBody = {
            email: mail,
            subject: formData.mail_subject,
            mail: htmlEditorValue
        }
        
        let sendMail = await sendMailApi(userToken, activeCase.case.id, reqBody)
   
        if (sendMail && sendMail.errorMessage) {
            dispatch(notificationActions.setError(sendMail))
        } else {  

            dispatch(notificationActions.setError({errorMessage: sendMail.message, type: 'success'}))
        } 

        setModalOpened(false)
        setLoading(false)
    }

    function setTemplateHandler(value) {
        setSelectedTemplate(value.data.value)
        setHtmlEditorValue(value.option.mail)

        if (value.data.value && value.option.mail) {
            setNotesValue(value.option.mail)
        }
        if (value.data.value && value.option.subject) {
            setSubjectValue(value.option.subject)
        }
    }

    useEffect(() => {
        let templates = getMailTemplates()

        if (templates && type) {
            
            let filteredTemplates = templates.filter(item => item.type == type)
            
            if (filteredTemplates && filteredTemplates.length > 0) {
                setTemplates(filteredTemplates)
            } else {
                setTemplates([
                    {label: 'No templates found', value: 'No templates found', manual_selection: true}
                ])
            }
        }
    }, [])

    return <>
        <button onClick={openModal} className={`${classes.item_blank} ${classes.item_blank_mail}`} title="Send Mail">
            {children}
        </button>
        {modalOpened && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModal} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeModal} modalTitle={'Send Mail'}>
                        <PannelBody padding='large' background={'var(--line-transparent)'}>
                            <div className={classes.modal_header}>
                                <div>
                                    {/* <div className={classes.name_label}>Name</div> */}
                                    <div className={classes.name_label}>
                                        {type}
                                    </div>
                                    {data && <div className={classes.name}>
                                        {type == 'Patient' && <>{formatPatientName(data)}</>}
                                        {type == 'Attorney' && <>{data.first_name} {data.last_name}</>}
                                        {type == 'Case Manager' && <>{data.first_name} {data.last_name}</>}
                                        {type == 'Law Firm' && <>{data.name}</>}
                                        {type == 'Insurance Carrier' && <>{data.name}</>}
                                        {type == 'Adjuster' && <>{data.first_name} {data.last_name}</>}
                                        {type == 'Nurse' && <>{data.first_name} {data.last_name}</>}
                                        {type == 'Negotiator' && <>{data.first_name} {data.last_name}</>}
                                        {type == 'Representative' && <>{data.name}</>}
                                    </div>}
                                </div>
                                <div>
                                    <div className={classes.phone}>
                                        {mail}
                                    </div>
                                </div>
                            </div>
                        </PannelBody>
                        <PannelBody>
                            <CustomSelect label={'Mail Template'} optionsData={templates} action={setTemplateHandler} preSelectedValue={selectedTemplate}/>
                        </PannelBody>
                        <PannelBody>
                            <form onSubmit={sendSms}>
                                <div className={classes.row}>
                                    <InputBox label={'Subject'} name={'mail_subject'} required={true} currentValue={subjectValue}/>
                                </div>
                                <div className={classes.row}>
                                    {/* <TextareaBox label={'Notes'} name={'mail_body'}  required={true} currentValue={notesValue}/> */}
                                    <WysiwygEditor data={notesValue} action={(value) => setHtmlEditorValue(value)}/>
                                </div>
                                <div className={classes.row}>
                                    <Button btnStyle={'full'} type={'submit'} isLoading={loading}>Submit</Button>
                                </div>
                            </form>
                        </PannelBody>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </>
}